<template>
  <!-- width="629px" -->
  <el-dialog
    title="选择时段"
    :visible.sync="handleVisible"
    width="90%"
    custom-class="timeSelectTable"
    :append-to-body="true"
  >
    <div>
      <el-table
        :data="gridData"
        size="mini"
        class="kTimeTable"
        style="width:100%;"
        :cell-style="cellStyle"
        @cell-click="handleCellClick"
        @cell-mouse-enter="handleCellMouseEnter"
        border
      >
        <el-table-column label="以小时为最小粒度，从周一零点开始至周日 24 点结束。默认全时段不投放，点击选择投放的时段" align="center">
          <el-table-column label="星期/时间" property="date" min-width="60" align="center"></el-table-column>
          <el-table-column label="00:00 ~ 12:00" align="center">
            <el-table-column label="0" align="center">
              <el-table-column property="time[0]" cindex="0" label="00" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[1]" cindex="1" label="00" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="1" align="center">
              <el-table-column property="time[2]" cindex="2" label="01" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[3]" cindex="3" label="01" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="2" align="center">
              <el-table-column property="time[4]" cindex="4" label="02" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[5]" cindex="5" label="02" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="3" align="center">
              <el-table-column property="time[6]" cindex="6" label="03" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[7]" cindex="7" label="03" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="4" align="center">
              <el-table-column property="time[8]" cindex="8" label="04" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[9]" cindex="9" label="04" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="5" align="center">
              <el-table-column property="time[10]" cindex="10" label="05" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[11]" cindex="11" label="05" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="6" align="center">
              <el-table-column property="time[12]" cindex="12" label="06" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[13]" cindex="13" label="06" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="7" align="center">
              <el-table-column property="time[14]" cindex="14" label="07" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[15]" cindex="15" label="07" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="8" align="center">
              <el-table-column property="time[16]" cindex="16" label="08" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[17]" cindex="17" label="08" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="9" align="center">
              <el-table-column property="time[18]" cindex="18" label="09" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[19]" cindex="19" label="09" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="10" align="center">
              <el-table-column property="time[20]" cindex="20" label="10" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[21]" cindex="21" label="10" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="11" align="center">
              <el-table-column property="time[22]" cindex="22" label="11" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[23]" cindex="23" label="11" min-width="20" align="center"></el-table-column>
            </el-table-column>
          </el-table-column>
          <el-table-column label="12:00 ~ 24:00" align="center">
            <el-table-column label="12" align="center">
              <el-table-column property="time[24]" cindex="24" label="12" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[25]" cindex="25" label="12" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="13" align="center">
              <el-table-column property="time[26]" cindex="26" label="13" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[27]" cindex="27" label="13" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="14" align="center">
              <el-table-column property="time[28]" cindex="28" label="14" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[29]" cindex="29" label="14" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="15" align="center">
              <el-table-column property="time[30]" cindex="30" label="15" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[31]" cindex="31" label="15" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="16" align="center">
              <el-table-column property="time[32]" cindex="32" label="16" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[33]" cindex="33" label="16" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="17" align="center">
              <el-table-column property="time[34]" cindex="34" label="17" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[35]" cindex="35" label="17" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="18" align="center">
              <el-table-column property="time[36]" cindex="36" label="18" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[37]" cindex="37" label="18" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="19" align="center">
              <el-table-column property="time[38]" cindex="38" label="19" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[39]" cindex="39" label="19" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="20" align="center">
              <el-table-column property="time[40]" cindex="40" label="20" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[41]" cindex="41" label="20" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="21" align="center">
              <el-table-column property="time[42]" cindex="42" label="21" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[43]" cindex="43" label="21" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="22" align="center">
              <el-table-column property="time[44]" cindex="44" label="22" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[45]" cindex="45" label="22" min-width="20" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="23" align="center">
              <el-table-column property="time[46]" cindex="46" label="23" min-width="20" align="center"></el-table-column>
              <el-table-column property="time[47]" cindex="47" label="23" min-width="20" align="center"></el-table-column>
            </el-table-column>
          </el-table-column>
        </el-table-column>
      </el-table>
      <div class="kTimeOption">
        <div class="flex">
          <div v-if="ceshi.length<1">点击选择时间段</div>
          <div v-else>已选择时间段</div>
          <div class="kTimeClear" @click="clearTime">清空选择</div>
        </div>
        <div class="kTimeSelect" v-if="ceshi.length>0">
          <p v-for="(item,index) in ceshi" :key="index">
            <span>{{item.week}}：</span>
            <span>{{item.textInfo}}</span>
          </p>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer" style="position:absolute;right:16px; bottom:16px;">
      <el-button @click="timeReset">取 消</el-button>
      <el-button type="primary" @click="handleVisible = false">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: Boolean,
    time: String
  },
  data() {
    return {
      doDraw: false,
      oldData: [],
      cellIndex: [],
      minIndex: null,
      maxIndex: null,
      cellValue: 0,
      ceshi: []
    }
  },
  computed: {
    handleVisible: {
      get: function() {
        return this.visible
      },
      set: function(newValue) {
        this.$emit('update:visible', newValue)
      }
    },
    gridData: {
      get: function() {
        var timeArr = this.time.split(',')
        var data = [
          {
            date: '星期一',
            time: [],
            row: 0
          },
          {
            date: '星期二',
            time: [],
            row: 1
          },
          {
            date: '星期三',
            time: [],
            row: 2
          },
          {
            date: '星期四',
            time: [],
            row: 3
          },
          {
            date: '星期五',
            time: [],
            row: 4
          },
          {
            date: '星期六',
            time: [],
            row: 5
          },
          {
            date: '星期日',
            time: [],
            row: 6
          }
        ]
        var ceshi = []

        data.forEach(function(value, index) {
          var k_week = {
            week: value.date,
            time: []
          }
          for (var i = 0; i < 48; i++) {
            var item = index * 48 + i
            if (timeArr[item] == 1) {
              data[index]['time'].push(1)

              var tt = Math.ceil((i - 1) / 2).toString()
              var text = tt < 10 ? '0' + tt : tt
              if (i % 2 == 0) {
                text += ':00'
                k_week['time'].push(text)
              } else if (i % 2 == 1) {
                text += ':30'
                k_week['time'].push(text)
              }
            } else {
              data[index]['time'].push(0)
            }
          }
          if (k_week['time'].length > 0) {
            var result = []
            i = 0
            result[i] = []

            result[i] = [k_week['time'][0]]
            //
            var d = new Date()
            var tet =
              d.getFullYear() +
              '/' +
              (d.getMonth() + 1 < 10
                ? '0' + (d.getMonth() + 1)
                : d.getMonth() + 1) +
              '/' +
              d.getDate()

            k_week['time'].reduce(function(prev, cur) {
              var stime =
                Date.parse(new Date(tet + ' ' + cur)) / 1000 -
                Date.parse(new Date(tet + ' ' + prev)) / 1000
              if (stime / 60 <= 30) {
                result[i].push(cur)
              } else {
                result[++i] = [cur]
              }
              return cur
            })

            k_week['time'] = result

            ceshi.push(k_week)
          }
        })
        ceshi.forEach(function(value, index) {
          var txt = []
          var dd = value.time

          for (var i = 0; i < dd.length; i++) {
            var ll = dd[i].length
            if (ll > 1) {
              if (dd[i][ll - 1].substr(3, 2) == '00') {
                txt.push(dd[i][0] + '~' + dd[i][ll - 1].substr(0, 3) + '30')
              } else if (dd[i][ll - 1].substr(3, 2) == '30') {
                var tn = parseInt(dd[i][ll - 1].substr(0, 2)) + 1
                var tt = tn < 10 ? '0' + tn : tn

                txt.push(dd[i][0] + '~' + tt + ':' + '00')
              }
            } else {
              if (dd[i][0].substr(3, 2) == '00') {
                txt.push(dd[i][0] + '~' + dd[i][0].substr(0, 3) + '30')
              } else if (dd[i][0].substr(3, 2) == '30') {
                var tn = parseInt(dd[i][0].substr(0, 2)) + 1
                var tt = tn < 10 ? '0' + tn : tn
                txt.push(dd[i][0] + '~' + tt + ':' + '00')
              }
            }
          }
          ceshi[index]['textInfo'] = txt.join(',')
        })

        this.ceshi = ceshi
        return data
      },
      set: function(data) {
        var newValue = ''

        data.forEach(function(value, index) {
          if (newValue) {
            newValue += ','
          }
          newValue += value['time'].join(',')
        })

        this.$emit('update:time', newValue)
      }
    }
  },
  methods: {
    cellStyle: function(cell) {
      var rowIndex = cell.rowIndex
      var columnIndex = cell.columnIndex - 1

      if (columnIndex < 0) {
        return {}
      }

      if (this.gridData[rowIndex]['time'][columnIndex] == 1) {
        return {
          'background-color': '#0b8fff',
          color: 'rgba(255,255,255,0)'
        }
      }

      return {
        color: 'rgba(255,255,255,0)'
      }
    },
    handleCellClick: function(row, column, cell, event) {
      if (column.property == 'date') {
        return
      }

      var rowIndex = row.row
      var columnIndex = column.property.split('[')[1].split(']')[0] - 0

      this.doDraw = !this.doDraw

      if (this.doDraw) {
        this.oldData = this.gridData
        this.cellIndex = [rowIndex, columnIndex]

        var value
        if (this.gridData[rowIndex]['time'][columnIndex]) {
          value = 0
        } else {
          value = 1
        }

        this.cellValue = value

        this.gridData[rowIndex]['time'][columnIndex] = value
        this.gridData = this.gridData
      }
    },
    handleCellMouseEnter: function(row, column, cell, event) {
      if (column.property == 'date') {
        return
      }

      var rowIndex = row.row
      var columnIndex = column.property.split('[')[1].split(']')[0] - 0

      if (this.doDraw) {
        var oldData = this.oldData

        var cellIndex = this.cellIndex
        var minIndex = this.minIndex
        var maxIndex = this.maxIndex

        // 求影响区域的边界值
        var rowIndexes = [rowIndex, cellIndex[0]]
        var columnIndexes = [columnIndex, cellIndex[1]]

        // 求当前选中区域值
        var minNow = [
          Math.min.apply(null, rowIndexes),
          Math.min.apply(null, columnIndexes)
        ]
        var maxNow = [
          Math.max.apply(null, rowIndexes),
          Math.max.apply(null, columnIndexes)
        ]

        if (minIndex) {
          rowIndexes.push(minIndex[0])
          columnIndexes.push(minIndex[1])
        }

        if (maxIndex) {
          rowIndexes.push(maxIndex[0])
          columnIndexes.push(maxIndex[1])
        }

        var min = [
          Math.min.apply(null, rowIndexes),
          Math.min.apply(null, columnIndexes)
        ]
        var max = [
          Math.max.apply(null, rowIndexes),
          Math.max.apply(null, columnIndexes)
        ]

        // 更新边界值
        this.minIndex = min
        this.maxIndex = max

        // 计算影响区域的值 并修改赋值
        for (var i = min[0]; i <= max[0]; i++) {
          for (var j = min[1]; j <= max[1]; j++) {
            // 如果在当前区域内，则修改为变化后的值，否则修改为原值
            if (
              i >= minNow[0] &&
              i <= maxNow[0] &&
              j >= minNow[1] &&
              j <= maxNow[1]
            ) {
              this.gridData[i]['time'][j] = this.cellValue
            } else {
              this.gridData[i]['time'][j] = oldData[i]['time'][j]
            }
          }
        }

        this.gridData = this.gridData
      }
    },
    clearTime: function() {
      this.ceshi = []
      var tt = []
      for (var i = 0; i < 336; i++) {
        tt.push(0)
      }
      this.$emit('update:time', tt.join(','))
      // this.time = tt.join(',')
    },
    timeReset: function() {
      this.clearTime()
      this.handleVisible = false
    }
  }
}
</script>
<style scoped>
/* 调整表头的字体大小 */
.el-table--mini {
    font-size: 10px;
}


</style>